import { render, staticRenderFns } from "./MdElementResource.vue?vue&type=template&id=d87f8ce4&scoped=true&"
import script from "./MdElementResource.vue?vue&type=script&lang=js&"
export * from "./MdElementResource.vue?vue&type=script&lang=js&"
import style0 from "./MdElementResource.vue?vue&type=style&index=0&id=d87f8ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87f8ce4",
  null
  
)

export default component.exports